export default __webpack_public_path__ + "static/media/36I-117143_-43590_0.d1d3c136.jpg";